import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const Pivot = () => {
  const tileId = useTargetAccumulatorTileId();
  const pivot = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.pivot);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('Pivot') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handlePivot = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'Pivot changed', isDefined(value) ? String(value) : 'null');

    return checkTargetAccumulatorWithTradeCapture({
      pivot: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.pivot">
      <TradeCaptureValidationWrapper validation={validation?.pivot}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          value={pivot}
          maxDecimals={9}
          onChange={handlePivot}
          allowNegative={false}
          size="sm"
          data-e2e="pivot"
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default Pivot;
